<template>
    <div class="stage-mission" :class="is_admin ? {editable} : ''">
        <div class="content">
            <div class="mission-actions pt-3">


                <template v-if="is_admin">

                    <!-- Description Editors for Admin -->

                    <h4 class="px-4 mb-3">Stage At-A-Glance</h4>

                    <div class="item" @click.prevent.stop="edit('teacher_description', 'Stage At-A-Glance for Teachers')"
                         :title="editable ? 'Click to edit.' : ''">
                        <h6>For Teachers</h6>
                        <markdown-text v-if="value( 'teacher_description' )" class="content" :content="value( 'teacher_description')" />
                        <p v-else class="empty-block content"></p>
                    </div>

                    <div class="item" @click.prevent.stop="edit('description', 'Stage At-A-Glance for Students')"
                         :title="editable ? 'Click to edit.' : ''">
                        <h6>For Students</h6>
                        <markdown-text v-if="value( 'description' )" class="content" :content="value( 'description')" />
                        <p v-else class="empty-block content"></p>
                    </div>

                </template>
                <template v-else-if="is_teacher">

                    <!-- Teachers will see description of for them as well as students but different titles. -->

                    <h4 class="px-4 mb-3">Stage At-A-Glance</h4>

                    <div class="item">
                        <p v-if="value( 'teacher_description' )">{{ value( 'teacher_description') }}</p>
                        <p v-else class="empty-block"></p>
                    </div>

                    <div class="item">
                        <h6>For Students</h6>
                        <p v-if="value( 'description' )">{{ value( 'description') }}</p>
                        <p v-else class="empty-block"></p>
                    </div>

                </template>

            </div>
            <div class="head" v-if="is_admin">
                <div class="item" @click.prevent.stop="edit('skill', 'Skills Taught' )"
                     :title="editable ? 'Click to edit.' : ''">
                    <h4>Objective</h4>
                    <markdown-text v-if="value( 'skill' )" class="content" :content="value( 'skill')" />
                    <p v-else class="empty-block content"></p>
                </div>
                <div class="item" @click.prevent.stop="edit('outcome', 'Outcome')"
                     :title="editable ? 'Click to edit.' : ''">
                    <h4>Outcome</h4>
                    <markdown-text v-if="value( 'outcome' )" class="content" :content="value( 'outcome')" />
                    <p v-else class="empty-block content"></p>
                </div>
                <div class="item" @click.prevent.stop="edit('deliverable', 'Stage Final Deliverable')"
                     :title="editable ? 'Click to edit.' : ''">
                    <h4>Student's Stage Mission</h4>
                    <markdown-text v-if="value( 'deliverable' )" class="content" :content="value( 'deliverable')" />
                    <p v-else class="empty-block content"></p>
                </div>
            </div>
            <div class="head" v-else-if="is_teacher">
                <div class="item">
                    <h4>Objective</h4>
                    <p v-if="value( 'skill' )">{{ value( 'skill') }}</p>
                    <p v-else class="empty-block"></p>
                </div>
                <div class="item">
                    <h4>Outcome</h4>
                    <p v-if="value( 'outcome' )">{{ value( 'outcome') }}</p>
                    <p v-else class="empty-block"></p>
                </div>
                <div class="item">
                    <h4>Student's Stage Mission</h4>
                    <p v-if="value( 'deliverable' )">{{ value( 'deliverable') }}</p>
                    <p v-else class="empty-block"></p>
                </div>
            </div>
            <div class="mission-actions">
<!--                <div class="item" @click.prevent.stop="edit('description', 'Stage Description')"-->
<!--                     :title="editable ? 'Click to edit.' : ''">-->
<!--                    <h4>Description</h4>-->
<!--                    <markdown-text v-if="value( 'description' )" class="content" :content="value( 'description')" />-->
<!--                    <p v-else class="empty-block content"></p>-->
<!--                </div>-->
<!--                <div class="item" @click.prevent.stop="edit('deliverable', 'Stage Final Deliverable')"-->
<!--                     :title="editable ? 'Click to edit.' : ''">-->
<!--                    <h4>Student's Stage Mission</h4>-->
<!--                    <markdown-text v-if="value( 'deliverable' )" class="content" :content="value( 'deliverable')" />-->
<!--                    <p v-else class="empty-block content"></p>-->
<!--                </div>-->

            </div>
        </div>

        <modal :id="utils.randomId({prefix: 'modal'})"
               :show="modal.enabled"
               v-if="modal.enabled"
               size="lg"
               @close="close()">
            <template #title>
                {{ selected_modal_statement.length === 0 ? 'Add' : 'Edit' }} {{ modal.title }}
            </template>

            <div class="form-group">
                            <textarea class="form-control"
                                      v-model="modal.text"
                                      rows="10"
                                      placeholder="Add text here."></textarea>
            </div>

            <template #footer>
                <button type="button"
                        @click="close()"
                        class="btn btn-warning">Cancel</button>
                <button type="button"
                        @click="save()"
                        class="btn btn-success ml-auto">Save</button>
            </template>
        </modal>

    </div>
</template>

<script>
import {mapActions} from "vuex";
import Modal from "@/Components/Common/Modal";
import utils from "@/mixins/utils";
import MarkdownText from "@/Components/Common/MarkdownText";

export default {
    name: "StageMission",
    components: {Modal, MarkdownText},
    props: ['path', 'stage', 'editable'],
    mixins: [utils],

    data(){
        return {
            modal: {
                enabled: false,
                key: '',
                title: '',
                text: '',
            }
        }
    },

    computed: {

        fragment_key(){
            return `stage_${this.stage}_misson_details`;
        },

        mission: {
            get(){
                if( typeof this.path.fragments[ this.fragment_key ] !== 'undefined' ){
                    return this.path.fragments[ this.fragment_key ];
                }
                return {};
            },

            set(val){
                this.path.fragments[ this.fragment_key ] = val;
            }
        },

        selected_modal_statement(){
            const text = typeof this.mission[ this.modal.key ] === 'undefined' ? '' : this.mission[ this.modal.key ];
            return text ? text : '';
        }

    },

    methods: {
        ...mapActions('repositories', {
            updateRepo: 'updateRepository',
        }),

        value(key){
            return this.mission[ key ] ? this.mission[ key ] : '';
        },

        edit(key, title){
            if( !this.editable ) return;

            this.modal.title    = title;
            this.modal.key      = key;
            this.modal.text     = this.selected_modal_statement;
            this.modal.enabled  = true;
        },

        close(){
            this.modal.enabled  = false;
            this.modal.title    = '';
            this.modal.key      = '';
            this.modal.text     = '';
        },

        save(){
            this.mission[ this.modal.key ] = this.modal.text;

            const fragments = {};
            fragments[ this.fragment_key ] = this.mission;
            this.updateRepo({scope: this.path.scope, fragments});
            this.close();
        }
    },

}
</script>

<style lang="scss" scoped>
.stage-mission{
    border: darken($light-borders, 5%) solid 1px;
    border-radius: 0.65rem;
    box-shadow: rgba($dark, 0.15) 0 2px 6px;

    &.editable{
        .item{
            cursor: text;

            &:hover{
                > .content {
                    background: rgba(black, 0.1);
                }
            }
        }
    }

    .content{
        h4{
            font-weight: $font-weight-bold;
            font-size: 1.1rem;
            margin-bottom: 0.6rem;
            text-transform: uppercase;

            span{
                font-style: italic;
                text-transform: none;
            }
        }

        > .content {
            font-size: 1rem;
        }
    }

}

.head{
    display: flex;
    align-items: stretch;
    margin-bottom: 2rem;

    .item {
        display: flex;
        flex-direction: column;
        flex: 0 0 33.33333%;
        width: 33.33333%;
        padding: 1.5rem 0.7rem 1.5rem 2rem;
        position: relative;
        background: $success;
        color: white;

        &:first-child {
            background: $success;
            color: white;
            padding-left: 1.5rem;
            //border-radius: 0.6rem 0 0 0;
        }

        &:nth-child(2) {
            background: darken($success, 5%);
            color: white;
            padding-left: 1.5rem;

            &:after{
                background: darken($success, 5%);
            }
        }

        &:last-child {
            //border-radius: 0 0.6rem 0 0;
            background: darken($success, 10%);
            padding-right: 1.5rem;

            &:after {
                display: none;
            }
        }

        &:after {
            content: '';
            position: absolute;
            top: 0;
            right: -.95rem;
            width: 1rem;
            height: 100%;
            background: $success;
            clip-path: polygon(0 0, 100% 50%, 0 100%);
            z-index: 1;
        }
    }

}

.mission-actions{
    .item{
        margin-bottom: 2rem;
        padding: 0 1.5rem;
    }
}

.empty-block{
    &:after{
        content: 'No text have been added to this section.';
        font-style: italic;
    }
}

.editable{
    .empty-block{
        &:after{
            content: 'No text have been added to this section. Click to edit.';
        }
    }
}

</style>
